import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e328548"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-card__description" }
const _hoisted_2 = { class: "task-card__info" }
const _hoisted_3 = { class: "task-card__info-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-card__info-label" }, "Project:", -1))
const _hoisted_5 = { class: "task-card__info-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-card__info-label" }, "Time:", -1))
const _hoisted_7 = { class: "task-card__timer" }
const _hoisted_8 = { class: "task-card__actions" }

import { ref } from 'vue';

import DeleteTaskModal from '@/components/tasks/partials/DeleteTaskModal.vue';
import EditTaskModal from '@/components/tasks/partials/EditTaskModal.vue';
import DSCard from './shared/DSCard.vue';
import DSButton from '@/design-system/DSButton.vue';
import DSBadge from '@/design-system/DSBadge.vue';

import TaskInterface from '../interfaces/Task.interface';
import formatTimer from '@/hooks/formatTimer';

import { useStore } from '@/store';
import { CREATE_TASK_SESSION, FINISH_TASK_SESSION, SET_ACTIVE_TASK } from '@/store/types/actions';
import { NEW_ACTIVE_TASK } from '@/store/types/mutations';

interface Props {
  task: TaskInterface;
  isGridLayout: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskCard',
  props: {
    task: {},
    isGridLayout: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const request_pending = ref([] as number[]);
const store = useStore();
const deleteTaskModal = ref(DeleteTaskModal);
const editTaskModal = ref(EditTaskModal);

const handleDeleteButtonClick = () => {
  deleteTaskModal.value.openModal(props.task);
};

const handleEditButtonClick = () => {
  editTaskModal.value.openModal(props.task);
};

const isRequestPending = (task: TaskInterface) => {
  return request_pending.value.includes(task.id);
};

const handleTask = async (task: TaskInterface) => {
  if (task.lastSessionStartedAt) {
    await store.dispatch(FINISH_TASK_SESSION, task);
    return store.commit(NEW_ACTIVE_TASK, {});
  }

  const new_task = await store.dispatch(CREATE_TASK_SESSION, task);
  await store.dispatch(SET_ACTIVE_TASK, new_task);
};

const handleInitTask = async (task: TaskInterface) => {
  request_pending.value.push(task.id);
  await handleTask(task);
  request_pending.value = request_pending.value.filter((task_id: string | number) => task_id !== task.id);
};

const getTaskIcon = (task: TaskInterface) => {
  return task.lastSessionStartedAt ? 'pause' : 'play_arrow';
};

const getTaskTime = (task: TaskInterface) => {
  return task.total_time_spent || task.time_spent;
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DSCard, {
      class: "task-card",
      shadow: "md"
    }, {
      header: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.task.description), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.task.project?.name)
              ? (_openBlock(), _createBlock(DSBadge, {
                  key: 0,
                  label: _ctx.task.project.name,
                  variant: "secondary",
                  size: "sm"
                }, null, 8, ["label"]))
              : (_openBlock(), _createBlock(DSBadge, {
                  key: 1,
                  label: "No project",
                  variant: "info",
                  size: "sm"
                }))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_icon, {
                name: "schedule",
                size: "18px"
              }),
              _createElementVNode("strong", null, _toDisplayString(_unref(formatTimer)(getTaskTime(_ctx.task))), 1)
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(DSButton, {
            loading: isRequestPending(_ctx.task),
            icon: getTaskIcon(_ctx.task),
            variant: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleInitTask(_ctx.task))),
            "aria-label": "Play task"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.task.lastSessionStartedAt ? 'Pause' : 'Play'), 1)
            ]),
            _: 1
          }, 8, ["loading", "icon"]),
          _createVNode(DSButton, {
            icon: "edit",
            variant: "outline",
            onClick: handleEditButtonClick,
            "aria-label": "Edit task"
          }),
          _createVNode(DSButton, {
            icon: "delete",
            variant: "danger",
            onClick: handleDeleteButtonClick,
            "aria-label": "Delete task"
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(DeleteTaskModal, {
      ref_key: "deleteTaskModal",
      ref: deleteTaskModal
    }, null, 512),
    _createVNode(EditTaskModal, {
      ref_key: "editTaskModal",
      ref: editTaskModal
    }, null, 512)
  ], 64))
}
}

})